/* apps/main/src/clark-widget/widget.css — RUN WW.
   New rules only, for markup this widget adds beyond the existing homepage exhibit
   (.ck-juris/.ck-bar/.ck-chip/.ck-try are already styled by master_final.html and untouched here).
   🔴 RUN CN — THE FIVE TOKENS THIS FILE WAS BUILT ON DO NOT EXIST ON THIS PAGE.
   The line below used to read "Uses the homepage's own --page/--ink/--brand tokens, not --cc-*".
   Measured in the browser on /: `--ink`, `--ink-secondary`, `--brand`, `--edge` and `--hairline`
   all resolve to the EMPTY STRING. `color: var(--ink)` with no fallback is an invalid declaration,
   so the ink simply INHERITED — rgb(20,20,23), the page body's near-black — and this widget lives
   inside `.ck-card`, which is a navy gradient (rgb(31,61,122) → rgb(0,35,104)).
   Composited against the darkest stop that is **1.26:1** against a 4.5 bar. Not "hard to read":
   very nearly invisible, and it is the visitor's own question during the whole thinking phase plus
   every word of the capped and error states.
   ⚠️ RUN CV reported this as the ANSWER rendering dark-on-dark. On this base the answer never
   paints inline at all — CH3 navigates to /clark — so `phase === "answer"` and
   `phase === "conversational"` are unreachable. What paints is `.ckw-asked` (thinking, error,
   capped) and `.ckw-reply` (error, capped). Same two rules, different text.
   The fix is REUSE, not invention: `--cc-on-chrome*` is the family the surrounding exhibit already
   uses for ink on this chrome (`.ck-try-label` is `--cc-on-chrome-faint`). Measured worst-case
   against every gradient stop, in all three themes this run drives:
       --cc-on-chrome        light 10.46  dark 14.13  gavel 10.99   → .ckw-asked
       --cc-on-chrome-faint  light  4.90  dark  6.15  gavel  5.12   → .ckw-reply
   🔴 `--cc-error` is NOT usable here — 1.92 light / 2.18 gavel. An error message a visitor cannot
   read is worse than one that is not red, so the error reply takes the same ink as any other and
   the error signal stays in the words.
   ClarkAnswerV2's own answer.css/answerV2.css (bundled in via its JS import) carries the --cc-*
   rail styling and needs themes.css loaded on the page for those tokens to resolve. */

.ckw-root { display: flex; flex-direction: column; gap: 0; }

.ckw-turn { margin-top: 18px; text-align: left; }

.ckw-asked {
  font-family: var(--f-sans); font-size: 14px; font-weight: 600; color: var(--cc-on-chrome);
  margin: 0 0 10px; padding-bottom: 10px; border-bottom: 1px solid var(--cc-on-chrome-line);
}

.ckw-reply {
  font-family: var(--f-sans); font-size: 14.5px; line-height: 1.6; color: var(--cc-on-chrome-faint);
  margin: 0; white-space: pre-wrap;
}

/* See the header: --cc-error is 1.92:1 on this card in light and 2.18:1 in gavel. */
.ckw-turn--error .ckw-reply { color: var(--cc-on-chrome); }

.ckw-dots { display: flex; gap: 5px; align-items: center; padding: 4px 0; }
.ckw-dots span {
  width: 6px; height: 6px; border-radius: 50%; background: var(--cc-on-chrome); opacity: .35;
  animation: ckw-pulse 1.1s ease-in-out infinite;
}
.ckw-dots span:nth-child(2) { animation-delay: .15s; }
.ckw-dots span:nth-child(3) { animation-delay: .3s; }
@keyframes ckw-pulse { 0%, 100% { opacity: .25; transform: scale(0.85); } 50% { opacity: .9; transform: scale(1); } }
@media (prefers-reduced-motion: reduce) { .ckw-dots span { animation: none; opacity: .6; } }

.ckw-capped-ctas { display: flex; gap: 10px; margin-top: 14px; }
.ckw-cta-primary, .ckw-cta-secondary {
  font-family: var(--f-sans); font-size: 13.5px; font-weight: 600; border-radius: 999px;
  padding: 9px 18px; cursor: pointer; border: none;
}
/* A filled pill in --cc-accent-fill is 1:1 against this card in light (#003A8F on #002368) — a
   button with no edge against its own ground. The white pill is the same treatment the page header
   already gives "Get started →", and its label sits on the pill, not on the card. */
.ckw-cta-primary { background: var(--cc-on-chrome); color: var(--cc-accent-fill); }
.ckw-cta-primary:hover { transform: translateY(-1px); }
.ckw-cta-secondary { background: transparent; color: var(--cc-on-chrome); border: 1.4px solid var(--cc-on-chrome-edge-strong); }
.ckw-cta-secondary:hover { border-color: var(--cc-on-chrome); }

@media (max-width: 480px) {
  .ckw-capped-ctas { flex-direction: column; }
  .ckw-cta-primary, .ckw-cta-secondary { width: 100%; }
}
